import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { SVG_COMPONENTS } from '@/assets/admin';

interface SelectionIndicatorProps {
  selected?: boolean;
  size?: number;
  borderWidth?: number;
  /** Border color when unselected. Defaults to the active admin theme's
   *  table border token. */
  color?: string;
  /** Fill/border color when selected. Defaults to admin focus accent. */
  selectedColor?: string;
  checkColor?: string;
  style?: ViewStyle;
}

export const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({
  selected = false,
  size = 16,
  borderWidth = 2,
  color,
  selectedColor,
  checkColor = '#FFFFFF',
  style,
}) => {
  const { admin } = useAdminColors();
  const resolvedColor = color ?? admin.dataTable.border;
  const resolvedSelectedColor = selectedColor ?? admin.formInput.borderFocused;

  const dimensionStyle = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderWidth,
    borderColor: selected ? resolvedSelectedColor : resolvedColor,
    backgroundColor: selected ? resolvedSelectedColor : 'transparent',
  } as ViewStyle;

  const checkSize = Math.max(8, Math.round(size * 0.6));

  return (
    <View style={[styles.container, dimensionStyle, style]}>
      {selected && (
        <SVG_COMPONENTS.CHECK_CIRCLE width={checkSize} height={checkSize} color={checkColor} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
